import {
	hamburgerButton,
	overlay,
	spacesMediaNavigation,
	searchInput,
	stickyEls,
	calendarPopup,
	calendars,
	mqCalendar,
	calendarCloseItems,
} from './lib/elements.js'
import {
	toggleMenu,
	handleMenuClick,
	navigateSpacesMedia,
	triggerFacetWPSearch,
	makeSticky,
	openCalendarDialog,
	destroyCalendarPopup,
} from './lib/handlers.js'
import { handleFirstTab, disableAnimationOnResize } from './lib/lib.js'

// Hamburger toggle
hamburgerButton.addEventListener('click', toggleMenu)
overlay.addEventListener('click', toggleMenu)
document.addEventListener('keyup', toggleMenu)

// Handle main menu clicks
document.addEventListener('click', handleMenuClick)
document.addEventListener('keyup', handleMenuClick)

// Remove :focus outline unless user is using the keyboard to navigate
window.addEventListener('keydown', handleFirstTab)

// Disable animations on window resize to improve performace
window.addEventListener('resize', disableAnimationOnResize)

if (spacesMediaNavigation) {
	spacesMediaNavigation.forEach((item) => {
		item.addEventListener('click', navigateSpacesMedia)
	})
}

// Disable Facet Wp Auto Refresh
;(function ($) {
	// Refresh on click
	$(() => {
		if (typeof FWP !== 'undefined') {
			FWP.auto_refresh = false
		}
	})
	$(document).on('facetwp-loaded', () => {
		$('html, body').animate({ scrollTop: 0 }, 500)
	})
})(jQuery)

if (searchInput) {
	searchInput.addEventListener('keypress', triggerFacetWPSearch)
}

// Make items sticky if enough space
if (stickyEls) {
	stickyEls.forEach((item) => {
		makeSticky(item)
	})
}

if (calendarPopup && calendars) {
	calendars.forEach((item) => {
		// makeSticky(item)
		item.addEventListener('click', openCalendarDialog)
	})

	calendarCloseItems.forEach((item) => {
		item.addEventListener('click', destroyCalendarPopup)
	})
	document.addEventListener('keyup', destroyCalendarPopup)
}
